<!-- 
    COMPONENT LETTER
-->


<!---------- SCRIPT ---------->

<script lang="ts">
    import { deglingos } from '../store/store'
</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">

    .letterImage {
        width: 100px;
        height: 120px;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        cursor: pointer;
    }

    .animatedMail {
        position: absolute;
        height: 150px;
        width: 200px;
        -webkit-transition: .4s;
        -moz-transition: .4s;
        transition: .4s;
    
        &__body {
            position: absolute;
            bottom: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 100px 200px;
            border-color: transparent transparent $color_primary transparent;
            z-index: 2;
        }
    
        &__topFold {
            position: absolute;
            top: 50px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 50px 100px 0 100px;
            -webkit-transform-origin: 50% 0%;
            -webkit-transition: transform .4s .4s, z-index .2s .4s;
            -moz-transform-origin: 50% 0%;
            -moz-transition: transform .4s .4s, z-index .2s .4s;
            transform-origin: 50% 0%;
            transition: transform .4s .4s, z-index .2s .4s;
            border-color: $color_primary_plus_plus transparent transparent transparent;
            z-index: 2;
        }
        
        &__backFold {
            position: absolute;
            bottom: 0;
            width: 200px;
            height: 100px;
            background: $color_primary_plus_plus; //#cf4a43;
            z-index: 0;
            &__deglingos {
                border-right: 1px solid $color_primary_plus;
            }
        }
        
        &__leftFold {
            position: absolute;
            bottom: 0;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 50px 0 50px 100px;
            border-color: transparent transparent transparent $color_primary_plus;
            z-index: 2;
        }
        
        &__letter {
            left: 20px;
            bottom: 0px;
            position: absolute;
            width: 160px;
            height: 60px;
            background: white;
            z-index: 1;
            overflow: hidden;
            -webkit-transition: .4s .2s;
            -moz-transition: .4s .2s;
            transition: .4s .2s;
            
            &__border {
                height: 10px;
                width: 100%;
                background: repeating-linear-gradient(
                    -45deg,
                    $color_primary,
                    $color_primary 8px,
                    transparent 8px,
                    transparent 18px
                );
            }
            
            &__title {
                margin-top: 10px;
                margin-left: 5px;
                height: 10px;
                width: 40%;
                background: $color_primary; // #cb5a5e;
            }

            &__context {
                margin-top: 10px;
                margin-left: 5px;
                height: 10px;
                width: 20%;
                background: $color_primary; // #cb5a5e;
                font-size: small;
            }

            &__text {
                padding: 12px 0 0 0;
                text-shadow: none;
            }
            
            &__stamp {
                margin-top: 30px;
                margin-left: 120px;
                border-radius: 100%;
                height: 30px;
                width: 30px;
                background: $color_primary;
                background-image: url("../images/kortefa_logo_background_blue.svg");
                opacity: 0.3;
            }
        }
    }

    .shadow {
        position: absolute;
        top: 200px;
        left: 100%;
        width: 400px;
        height: 30px;
        transition: .4s;
        transform: translateX(-50%);
        -webkit-transition: .4s;
        -webkit-transform: translateX(-50%);
        -moz-transition: .4s;
        -moz-transform: translateX(-50%);
        border-radius: 100%;
        background: radial-gradient($color_primary, rgba(0,0,0,0.0), rgba(0,0,0,0.0));
    }

    .letterImage:hover {
        
        .animatedMail {
            transform: translateY(50px);
            -webkit-transform: translateY(50px);
            -moz-transform: translateY(50px);
        }
        
        .animatedMail .animatedMail__topFold {
            transition: transform .4s, z-index .2s;
            transform: rotateX(180deg);
            -webkit-transition: transform .4s, z-index .2s;
            -webkit-transform: rotateX(180deg);
            -moz-transition: transform .4s, z-index .2s;
            -moz-transform: rotateX(180deg);
            z-index: 0;
        }
        
        .animatedMail .animatedMail__letter {
            height: 180px;
        }
        
        .shadow {
        width: 250px;
        }
    }

</style>
  
  
<!---------- TEMPLATE ---------->

<div class="letterImage">
    <div class="animatedMail">
        <div class="animatedMail__backFold" class:animatedMail__backFold__deglingos={$deglingos}></div>
        <div class="animatedMail__letter">
            <div class="animatedMail__letter__border"></div>
            <div class="animatedMail__letter__title"></div>
            <div class="animatedMail__letter__context">
                <div class="animatedMail__letter__text">contact@kortefa.net</div>
            </div>
            <div class="animatedMail__letter__stamp"></div>
        </div>
        <div class="animatedMail__topFold"></div>
        <div class="animatedMail__body"></div>
        <div class="animatedMail__leftFold"></div>
    </div>
    <div class="shadow"></div>
</div>